
jQuery(document).ready(function($) {

  /* Base
  ========================================================================== */

  // Hover submenu

  if (window.innerWidth >= 992) {
    $("#primary-menu .menu-item-has-children").hover(function () {
      $(this).find("ul").toggleClass("open");
    })
  }

  // Lazy loading
  /** @see http://jquery.eisbehr.de/lazy/#about */
  if (frontendajax.gblmaster_lazy_load) {
    $(function() {
          $('figure.lazy,img.lazy').Lazy({});
      });
  }

  // Anchor animate scroll
  //----------------
  // here an example for the navigation on the Base page
  $(".thebase-navigation li a").click(function () {
    var divHref = $(this).attr("href");
    var divPosition = $(divHref).offset().top;
    $("html, body").stop().animate({
      scrollTop: divPosition - 150
    }, 800);
    return false;
  });

  $(".scrollTo").click(function () {
    var divHref = $(this).attr("href");
    var divPosition = $(divHref).offset().top;
    $("html, body").stop().animate({
      scrollTop: divPosition - 200
    }, 800);
    return false;
  });

  //menuHoverClass
  $("#primary-menu").hover(function () {
    $(this).addClass("go_hover");  //Add the active class to the area is hovered
  }, function () {
    $(this).removeClass("go_hover");
  });

  $("#primary-menu .menu-item-has-children").hover(function () {
    $("body").addClass("body_menu_hover");  //Add the active class to the area is hovered
  }, function () {
    $("body").removeClass("body_menu_hover");
  });


  /* Client
   ========================================================================== */


  $(".btn.load-more").click(function () {
    var clicker = $(this);
    var page = clicker.data("page");
    clicker.data("page", page + 1)
    $.ajax({ // you can also use $.post here
      url: frontendajax.ajaxurl, // AJAX handler
      data: {
        'action': 'loadmorenews',
        'page': page
      },
      type: 'POST',
      beforeSend: function (xhr) {
        //button.text('Loading...'); // change the button text, you can also add a preloader image
      },
      success: function (data) {

        $(".news-ul-wrapper").append(data);
        if ($(".news-ul-wrapper li").length >= clicker.data("total") ) {
          clicker.hide();
        }
      }
    });
    return false;
  });


  /* Modal
========================================================================== */


  $(document)
    .on('click', '.modal-opener', function(event) {
      $("body").addClass('modal-open');
      event.preventDefault();
      $("#"+$(this).data("modal")).addClass('open');
    }).on('click', '.modal .close', function(event) {
      close_modal()
    });

  $('.modal').on('click', function(e) {
    if (e.target !== this) return;
    close_modal()
  });

  $("body").keydown(function(e) {
    if (e.keyCode == 27) {
      close_modal()
    }
  });

  function close_modal() {
    $(".modal").removeClass('open');
    $("body").removeClass('modal-open');
  }


  /* Tabs
========================================================================== */


  if ($(".wrapper-tabs").length > 0 ) {

    jQuery(document).on('mouseenter', '.tab-menu .tab-menu-item a', function () {
      jQuery(this).trigger('click');
    });

    $(".wrapper-tabs .tab-menu-item a").click(function(event) {
      event.preventDefault();
      var $parents = $(this).parents(".wrapper-tabs");
      $parents.find(".tab-menu-item").removeClass('active in')
      $(this).parent("li").addClass('active in')

      $parents.find(".tab-content-item").removeClass('active in')
      $parents.find($(this).attr("href")).addClass("active in")

      return false;
    });
  }


/* sticky Menu
========================================================================== */

  if (window.innerWidth >= 992) {
    // init sticky menu
    var lastScrollPosition = 0;
    currentScrollPosition = $(window).scrollTop();
    $("body").addClass("has-sticky-menu");

    if (currentScrollPosition > 20) {
      $("body").addClass("sticky-menu");
    } else {
      $("body").removeClass("sticky-menu");
    }
    lastScrollPosition = currentScrollPosition;
  }

  $(window).scroll(function () {
    currentScrollPosition = $(window).scrollTop();
    if (currentScrollPosition > 20) {
      $("body").addClass("sticky-menu");
    } else {
      $("body").removeClass("sticky-menu");
    }

    if (currentScrollPosition > lastScrollPosition) {
      $("body").removeClass("scroll-up").addClass("scroll-down");
    } else {
      $("body").removeClass("scroll-down").addClass("scroll-up");
    }

    lastScrollPosition = currentScrollPosition;
  });




  //SVG ANIMATION
  $(".pictoMoving").each(function(index, el) {
    var animation = bodymovin.loadAnimation({
      container: $(this)[0],
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/wp-content/themes/gblmaster/json/'+$(this).data("anim")+'/data.json'
    })
  });


})
